// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.m-b-32[data-v-cffa9a94] {\n  margin-bottom: 2rem; /* 32px */\n}\n.span-2[data-v-cffa9a94] {\n  grid-column: span 2 / span 2;\n}\n.container-charts[data-v-cffa9a94] {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n}\n\n", ""]);
// Exports
module.exports = exports;
